import type { IconData } from '@stacksjs/iconify-core'

export const inbox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M32 16v480h448V16Zm416 288H342.111l-32 64H201.889l-32-64H64V144h384Zm0-256v64H64V48ZM64 464V336h86.111l32 64h147.778l32-64H448v128Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default inbox
